<template>
  <div class="Wdgt-Auth-Module">
    <p class="Wdgt-Auth-Module__text Wdgt-Auth-Module__text--thin">Проверьте почту</p>
    <TypographyHint class="Wdgt-Auth-Module__hint">Если аккаунт с таким e-mail существует, мы отправили ссылку для входа. Ссылка действительна 15 минут.</TypographyHint>
    <ButtonMain class="Wdgt-Auth-Module__button" :width="'100%'" @click="toClose">Продолжить</ButtonMain>
  </div>
</template>

<script setup>
  import { useStore } from 'vuex';
  import DROPDOWN_NAMES from '@shared/constants/dropdowns/dropdownsName.js';
  //-----------------------
  import TypographyHint from '@ui/Typography/TypographyHint/TypographyHint.vue';
  import ButtonMain from '@shared/UI/Buttons/ButtonMain/ButtonMain.vue';
  //-----------------------
  const store = useStore();
  //-----------------------
  const POPUP_NAME = DROPDOWN_NAMES.auth;
  //-----------------------
  //Закрыть виджет: дальше действие за юзером в почте — как и после сброса пароля
  const toClose = () => store.dispatch('Dropdowns/removeTheDropdown', POPUP_NAME);
</script>

<style lang="scss">
  @import '../../styles/Wdgt-Auth-Module.scss';
</style>
